import { useState } from "react";
import ApplyForm from "../Components/ApplyForm";

import Week from "../Components/Week";

export default function Robotics() {
          const [openIndex, setOpenIndex] = useState(null);
        
          const toggleFAQ = (index) => {
            setOpenIndex(openIndex === index ? null : index);
          };
    const syllabusData = [
        {
          title: "Week 1: Introduction to Robotics & Embedded Systems",
        
          description: [
         
            "What is Robotics? Basics of automation",
            " Introduction to AI-powered Robotics",
            "Overview of Microcontrollers (ESP32, Arduino, Raspberry Pi)",
            "Introduction to Servo Motors, Stepper Motors, DC Motors",
            "Sensors & Actuators: Ultrasonic, IR, LIDAR, Encoders, IMU"
          ],
        },
        {
            title: "Week 2: Python for Robotics",
          
            description: [
              "Python Basics for Embedded Systems",
              " Introduction to MicroPython and CircuitPython",
              " Controlling GPIO pins using Python",
              " Interfacing Motors, Sensors, and Displays with Python"
            ],
          },
          {
            title: "Week 3: Robot Programming & AI Integration",
          
            description: [
              "Introduction to ROS (Robot Operating System)",
              "Basic Computer Vision with OpenCV",
              "AI-powered obstacle detection & object tracking",
              " Speech recognition with Whisper AI"
            ],
          },
          {
            title: "Week 4: Real-World Robotics Projects",
          
            description: [
              "Building a simple Line Following Robot",
              "AI-powered Voice Controlled Robot",
              "IoT-enabled Wi-Fi/Bluetooth Robot using ESP32",
             
            ],
          },
       
       
      ];
  const syllabusData_one = [
    {
      title: "Month 1: Fundamentals of Robotics & Embedded Systems",
    
      description: [
        "Understanding Microcontrollers (Arduino, ESP32, Raspberry Pi)",
        "Working with Motor Drivers (L293D, TB6612FNG)",
        "PWM control for Servo Motors, DC Motors, Stepper Motors",
        "Sensor Integration: IMU (MPU6050), LIDAR, Ultrasonic, IR"
      ],
    },
    {
        title: "Month 2: Python & AI for Robotics",
      
        description: [
          "Advanced Python for Robotics",
          "MicroPython & Embedded AI Programming",
          " Data handling with NumPy & Pandas",
          "Image Processing with OpenCV"
        ],
      },
      {
        title: "Month 3: AI & Machine Learning for Robotics",
      
        description: [
          "Introduction to Machine Learning & AI",
          "Implementing AI with TensorFlow Lite on Microcontrollers",
          "Computer Vision: Object Detection, Face Recognition",
          "Speech Processing with Whisper AI & Natural Language Processing (NLP)"
        ],
      },
      {
        title: "Month 4: IoT & Smart Robotics",
      
        description: [
          "Connecting Robotics with IoT (MQTT, Firebase, Blynk)",
          "Cloud Robotics & Remote Control via Wi-Fi & Bluetooth",
          " Smart Home Automation with AI-powered Robots",
         
        ],
      },
      {
        title: "Month 5: Autonomous Robotics & ROS (Robot Operating System)",
      
        description: [
          "Introduction to ROS2 & Gazebo Simulation",
          " Implementing SLAM (Simultaneous Localization & Mapping)",
          "AI-powered Path Planning & Obstacle Avoidance",
          " Building an Autonomous Robot"
        ],
      },
      {
        title: "Month 6: Capstone Projects & Deployment",
      
        description: [
          "Building a Full-Scale AI-Powered Robot",
          "AI-assisted Self-Balancing Robot",
          "AI-Powered Drone Programming",
          "Industry-Level Robotics Project"
        ],
      },
  ];
  const faqs = [
    {
      question: "Who is this course for?",
      answer:
        <> This course is designed for <span className="ans">students, engineers,</span>  and <span className="ans">tech enthusiasts</span> who want to build
        intelligent robots using <span className="ans">AI, Python, </span>and <span className="ans"> Microcontrollers</span>. It is beginner-friendly but also
        includes advanced concepts for professionals.
</>

    },
    {
        question: "What are the prerequisites for this course?",
        answer: (
          <>
          No prior experience is required! However, basic knowledge of <span className="ans">electronics, programming (Python/C++),</span>
           and <span className="ans">physics</span>  can be helpful.
          </>
        ),
      },
    {
      question: "Which microcontrollers will be covered?",
      answer: <> 
      We will work with:
      <p className="faq-answer fheading ms-2">🔹Arduino (Uno, Mega, Nano)
      </p>
    <p className="faq-answer fheading ms-2">🔹ESP32 & ESP8266
    </p>
    <p className="faq-answer fheading ms-2">🔹 Raspberry Pi (Zero, 4, Pico)
    </p>
   
</>,
    },
 

    {
      question: "Will we learn AI and Machine Learning?",
      answer:
       <>
      Yes! We will integrate AI-powered robotics using:
<p className="faq-answer fheading ms-2">🔹 TensorFlow Lite for Microcontrollers</p>
<p className="faq-answer fheading ms-2">🔹 Computer Vision with OpenCV
</p>
<p className="faq-answer fheading ms-2">🔹Speech Recognition with Whisper AI</p>


       </>
    },
    {
      question: "What kind of projects will we build?",
      answer:
        <>
        You will build <span className="ans">real-world robotics projects</span>, including:
        <p className="faq-answer fheading ms-2">🔹AI-powered Self-Driving Robot</p>
        <p className="faq-answer fheading ms-2">🔹Smart IoT Robot (Wi-Fi/Bluetooth Controlled)
        </p>
        <p className="faq-answer fheading ms-2">🔹 Voice-Controlled Robot using Whisper AI</p>
        <p className="faq-answer fheading ms-2">🔹Autonomous Path-Finding Robot
        </p>
        </>,
    },
    {
      question: "Will we learn ROS (Robot Operating System)?",
      answer:
        <>Yes! In the 6-month course, we cover <span className="ans">ROS2</span> and <span className="ans">Gazebo Simulation </span>for <span className="ans">autonomous robots</span>
and AI-powered navigation.</>,
    },
    {
      question: "What kind of motors and sensors will be used?",
      answer:
       <>
  You will learn to work with:
    <p className="faq-answer fheading ms-2">🔹  <span className="ans">Motors:</span> Servo Motors, Stepper Motors, DC Motors</p>
    <p className="faq-answer fheading ms-2">🔹<span className="ans">Sensors:</span>  IMU (MPU6050), LIDAR, Ultrasonic, IR, Encoders
    </p>
   
       </>
    },
    {
      question: "️How is this course different from others?",
      answer:
       <>
We are <span className="ans">the only institute in Jalandhar</span> offering AI-integrated Robotics training, with
real-world projects using <span className="ans">Whisper AI, ChatGPT,</span> and <span className="ans">Machine Learning models.</span>
       </>
    },
    {
      question: "Do I need to buy my own hardware?",
      answer:
       <>
    No! We provide <span className="ans">hands-on training </span>with all hardware components, but you can buy your own kit
    if you want to practice at home.
       </>
    },
    {
        question: "Will I get a certificate?",
        answer:
         <>
    Yes! Upon successful completion, you will receive an <span className="ans">industry-recognized certificate</span> from
    <span className="ans"> DigitalMonk</span>.
         </>
      },
      {
        question: "What career opportunities are available after this course?",
        answer:
         <>
    You can work in <span className="ans">Robotics, Embedded Systems, AI Development,</span> and <span className="ans">IoT</span>. Popular job roles
    include:
      <p className="faq-answer fheading ms-2">🔹 AI Robotics Engineer</p>
      <p className="faq-answer fheading ms-2">🔹 Embedded Firmware Developer
      </p>
      <p className="faq-answer fheading ms-2">🔹  IoT Engineer</p>
      <p className="faq-answer fheading ms-2">🔹 Automation Engineer
      </p>
         </>
      },
    {
        question: "How can I enroll?",
        answer:
         <>
     <p className="faq-answer fheading ms-2">📍  <span className="ans">Visit us at:</span> 2nd Floor DigitalMonk, Near Dominos, Doaba Chownk, Jalandhar, Punjab</p>
     <p className="faq-answer fheading ms-2">📞  <span className="ans">Call/WhatsApp:</span> +916284636956</p>
     <p className="faq-answer fheading ms-2">📅  <span className="ans">Next batch starts soon – Limited seats available!</span></p>
     <p className="faq-answer fheading ms-2">🚀  <span className="ans">Transform your career with React Native at CoderMonk</span></p>
         </>
      },
  ];
  return (
    <>
    <style jsx>{`
  .syllabus_heading {
    text-align: center;
    font-size: 3rem;
    margin-bottom: 2rem;
    color: #004085;
  }

  .card_container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    padding: 1rem;
  }

  .card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  .card_title {
    font-size: 1.5rem;
    color: #006a4f;
    margin-bottom: 1rem;
  }

  .card_sublist {
    list-style-type: circle;
    padding-left: 20px;
    margin: 0;
    color: #001f3f;
    font-weight: 600;
  }

  .card_subitem {
    margin-bottom: 0.5rem;
  }

  /* Media Query for max-width 768px */
  @media (max-width: 768px) {
    .card_container {
      grid-template-columns: 1fr;
    }
  }


`}</style>


    <div className="container-xxl py-5">
  <div className="container-fluid  d-flex align-items-center justify-content-center">
    <div className="row g-5">
      <div
        className="col-lg-6 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ minHeight: 400 }}
      >
        <div className="position-relative h-100">
          <img
            className="img-fluid position-absolute w-100 h-100"
            src="https://cdn.pixabay.com/photo/2024/03/11/19/15/ai-generated-8627457_640.png"
            alt=""
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>
      <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
      <div className='d-flex flex-start align-items-center justify-content-start mb-4 mt-2'>
          
                    <h6 className="sub_heading text-start">Syllabus</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
        <h1 className="mb-4 Heading">Robotics & Embedded AI Using Python</h1>
        <h6 style={{color:"#c63b36"}} className="mt-3">Master Robotics, AI, and Embedded Systems with Hands-on Training</h6>
        <p className="mb-4" style={{color:"#001f3f"}}>
        At  CoderMonk (Jalandhar, Punjab), we provide  cutting-edge robotics training with AI and
embedded systems. This course will teach you to build intelligent robots using Python,
 and  Computer Vision.
        </p>
       
     
        <a className="btn  py-3 px-5 mt-2 text-white" href="#form" style={{backgroundColor:"yellowgreen"}}>
        Join Now
        </a>
      </div>
    </div>
  </div>
</div>



      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">6-Months</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
    <div className="container-fluid card_container px-3">
  <div className="row">
    {syllabusData_one.map((module, index) => (
      <div key={index} className="col-lg-4 col-md-6 mb-4">
        <div className="card bgimg h-100 shadow-sm">
          <div className="card-body">
            <h3 className="card_title">{module.title}</h3>
            <h6 style={{color:"#c63b36"}}>{module.note}</h6>
            <ul className="card_sublist" style={{listStyleType:"disc"}}>
              {module.description.map((item, subIndex) => (
                <li key={subIndex}>
                  {typeof item === 'string' ? (
                    item
                  ) : (
                    <>
                      {item.text}
                      <ul className=" ms-3" style={{listStyleType:"circle"}}>
                        {item.subDescription.map((subItem, subDescIndex) => (
                          <li key={subDescIndex}>{subItem}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">45-Days</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
    <div className="container-fluid card_container px-3">
  <div className="row">
    {syllabusData.map((module, index) => (
      <div key={index} className="col-lg-6 col-md-6 mb-4">
        <div className="card bgimg h-100 shadow-sm">
          <div className="card-body">
            <h3 className="card_title">{module.title}</h3>
            <h6 style={{color:"#c63b36"}}>{module.note}</h6>
            <ul className="card_sublist" style={{listStyleType:"disc"}}>
              {module.description.map((item, subIndex) => (
                <li key={subIndex}>
                  {typeof item === 'string' ? (
                    item
                  ) : (
                    <>
                      {item.text}
                      <ul className=" ms-3" style={{listStyleType:"circle"}}>
                        {item.subDescription.map((subItem, subDescIndex) => (
                          <li key={subDescIndex}>{subItem}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">FAQs</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>

    <div className="faq-container mb-5">
     
     <div className="faq-list">
       {faqs.map((faq, index) => (
         <div key={index} className="faq-item">
           <div
             className="faq-header"
             onClick={() => toggleFAQ(index)}
            
           >
             <h2 className="faq-question  fheading">{faq.question}</h2>
             <span className="faq-icon">
               {openIndex === index ? "−" : "+"}
             </span>
           </div>
           {openIndex === index && (
             <p className="faq-answer fheading">{faq.answer}</p>
           )}
         </div>
       ))}
     </div>
   </div>
   
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Contact</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
    <ApplyForm/>
    <div className='container mt-5 mb-5'>
        <div className='row'>
            <div className='col-12'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.4728947145964!2d75.58318561066835!3d31.345927155633603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5bde4b978ac5%3A0xe6b30ccf89446f33!2sDigitalMonk!5e0!3m2!1sen!2sin!4v1737619055819!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "350px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
        </div>
    </div>
    </>
  );
}

